import { CombinedFactorRelationship } from '../constants-types/Enums';

export class ManagerScoreCardQuestion {
    id: string;
    text: string;
    checked = false;
}

export class ManagerScoreCard {
    factor1: string;
    factor2: string;
    factorCombination: CombinedFactorRelationship;
    question: ManagerScoreCardQuestion;
}
